function getOrCreateAnonId() {
  let id = localStorage.getItem(process.env.INTERCOM_USER_ID);
  if (!id) {
    id = "anon-" + ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
    localStorage.setItem(process.env.INTERCOM_USER_ID, id);
  }
  return id;
}

window.intercomSettings = {
  api_base: "https://api-iam.intercom.io",
  app_id:   process.env.INTERCOM_API_ID,
  user_id:  getOrCreateAnonId(),
};

const intercomLoader = () => {
  let existingIntercom = window.Intercom;

  if (typeof existingIntercom === "function") {
    // Intercom already loaded — just push updated settings
    existingIntercom("update", window.intercomSettings);

  } else {
    // Set up a stub that queues calls made before the real script loads
    let intercomStub = function() {
      intercomStub.callQueue.push(arguments);
    };

    intercomStub.callQueue = [];

    window.Intercom = intercomStub;

    let loadIntercomScript = function() {
      let intercomScript    = document.createElement("script");
      intercomScript.type   = "text/javascript";
      intercomScript.async  = true;
      intercomScript.src    = `https://widget.intercom.io/widget/${window.intercomSettings.app_id}`;
      intercomScript.onload = function() {
        window.Intercom("boot", window.intercomSettings);
      };

      let firstExistingScript = document.getElementsByTagName("script")[0];
      firstExistingScript.parentNode.insertBefore(intercomScript, firstExistingScript);
    };

    if (document.readyState === "complete") {
      loadIntercomScript();
    } else if (window.attachEvent) {
      window.attachEvent("onload", loadIntercomScript);
    } else {
      window.addEventListener("load", loadIntercomScript, false);
    }
  }
};

export default intercomLoader;
